import React from "react";
import { Box, Typography, Divider } from "@mui/material"
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const Statistics = ({ data, cards, titles, icons, symbol, customStyle }) => {
    if (!data) {
        return <div>data not found</div>;
    }

    return (
        <Box sx={customStyle || { border: '1px solid #d9d9d9', padding: '10px', borderRadius: '10px', marginBottom: '10px', display: 'flex', justifyContent: 'space-around' }}>

            {cards.map((card, index) => (
                <React.Fragment key={index}>
                        <Box sx={{ width: '25%', margin: '10px', position: 'relative', paddingLeft: '2px' }}>
                            <Typography sx={{ fontWeight: '600', fontSize: '24px', marginBottom: '5px', width: '82%' }}>
                                {symbol && symbol[card] ? symbol[card] : ''} <span style={{ fontFamily: 'Outfit' }}>{data[card].value.toLocaleString('en-US')}</span>
                            </Typography>
                            <Typography sx={{ fontSize: '16px', marginBottom: '5px' }}>
                                {titles[card]}
                            </Typography>
                            {data[card].change && data[card].percentage && <Box sx={{ display: 'flex', color: '#C3CADC' }}>
                                {data[card].increase
                                    ? <ArrowRightAltIcon sx={{ color: '#2FC655', transform: "rotate(-45deg)" }} />
                                    : <ArrowRightAltIcon sx={{ color: '#FF3E33', transform: "rotate(130deg)" }} />
                                }
                                <Typography sx={{ fontWeight: '500', fontFamily: 'Outfit' }}>
                                    {data[card].change}
                                </Typography>
                                <Typography sx={{ fontWeight: '500', marginLeft: '10px' }}>
                                    <span style={{ fontFamily: 'Outfit' }}>{data[card].percentage}</span> % this week
                                </Typography>
                            </Box>}
                            <Box sx={{ width: '40px', height: '40px', boxShadow: '0 0 12px #7C8DB51F', borderRadius: '10px', position: 'absolute', top: '3px', right: '1px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#81D0C1', opacity: '0.9' }}>
                                <span style={{opacity: '0.8', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{icons[card]}</span>
                            </Box>
                        </Box>
                        {((Object.keys(data).length - 1) !== index) && ((cards.length - 1) !== index) && <Divider orientation="vertical" flexItem />}
                    </React.Fragment>
            ))}
        </Box>
    )
}

export default Statistics